module.exports = "<div class=\"standard row page-takeover\"> <div class=page-takeover-content> <div class=col-wrapper> <div class=\"standard row content\"> <div class=\"parbase section col-md-12\"> <div class=section> <div class=hero-text> <h2 class=\"panel-heading tcom-theme-fg-primary view-title\">{{$ctrl.authorable.landing_leadline}}</h2> <h2 class=sub-heading>{{$ctrl.authorable.landing_subLeadline}}</h2> </div> </div> </div> </div> </div> </div> </div> <search-form tabs=$ctrl.authorable.landing_verticalTabs form-data=$ctrl.form_data></search-form> ";


//////////////////
// WEBPACK FOOTER
// ./src/containers/search/search.html
// module id = 628
// module chunks = 0